export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-insider",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace-insider",
      },
      // {
      //   url: "/field/warehouse",
      //   name: "창고",
      //   icon: "w-line",
      //   activeCode: "field-warehouse",
      // },
    ],
  },
  {
    url: "/tab/101",
    name: "안전·보건 경영방침",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "안전·보건 조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/453",
        name: "안전·보건조직 체계도(총괄)",
        icon: "w-line",
        activeCode: "",
        groupName: ["453"],
      },
      {
        url: "/tab/126",
        name: "안전·보건조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/282",
        name: "안전보건관리책임자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["282"],
      },
      {
        url: "/tab/297",
        name: "관리감독자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["297"],
      },
      {
        url: "/tab/440",
        name: "안전·보건관리자 및 산업보건의 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["440"],
      },
      {
        url: "/tab/436",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["436"],
      },
      {
        url: "/tab/433",
        name: "종사자 정보",
        icon: "w-line",
        activeCode: "employees",
        groupName: ["433", "employees"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/437",
        name: "안전·보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["437"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/434",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["434"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
      {
        url: "/tab/442/page",
        name: "종사자별 교육 이수 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["442"],
      },
    ],
  },
  {
    url: "/",
    name: "근골격계 유해요인조사",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/470",
        name: "정기 근골격계질환 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["470"],
      },
      {
        url: "/tab/471",
        name: "수시 근골격계질환 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["471"],
      },
      {
        url: "/tab/293",
        name: "근골격계부담작업 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["293"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/160",
        name: "유해·위험요인 점검(개선)사항 요청",
        icon: "w-line",
        activeCode: "",
        groupName: ["160"],
      },
      {
        url: "/tab/444",
        name: "TBM 실행 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["444"],
      },
      {
        url: "/tab/137",
        name: "안전·보건 점검 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/100",
        name: "안전·보건 합동점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/289",
        name: "안전·보건 순회점검표(사무실)",
        icon: "w-line",
        activeCode: "",
        groupName: ["289"],
      },
      {
        url: "/tab/439",
        name: "안전 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["439"],
      },
      {
        url: "/tab/290",
        name: "보건 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["290"],
      },
      {
        url: "/tab/438",
        name: "휴게시설 주요 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["438"],
      },
      {
        url: "/tab/435",
        name: "안전·보건 점검 결과",
        icon: "w-line",
        activeCode: "",
        groupName: ["435"],
      },
      {
        url: "/tab/163",
        name: "일일안전보건점검일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["163"],
      },
      {
        url: "/tab/292",
        name: "근골격계 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["292"],
      },
      {
        url: "/tab/168",
        name: "시설물 관리(공통)",
        icon: "w-line",
        activeCode: "",
        groupName: ["168"],
      },
      {
        url: "/tab/198",
        name: "계절성 업무에 따른 관리대책",
        icon: "w-line",
        activeCode: "",
        groupName: ["198"],
      },
      {
        url: "/tab/580",
        name: "신호 및 연락체계",
        icon: "w-line",
        activeCode: "",
        groupName: ["580"],
      },
    ],
  },
  {
    url: "/",
    name: "종사자의견청취",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/152",
        name: "산업안전보건위원회",
        icon: "w-line",
        activeCode: "",
        groupName: ["152"],
      },
      {
        url: "/tab/473",
        name: "종사자 설문조사",
        icon: "w-line",
        activeCode: "",
        groupName: ["473"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건관리 이행",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/445",
        name: "안전보건관리책임자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["445"],
      },
      {
        url: "/tab/446",
        name: "관리감독자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["446"],
      },
      {
        url: "/tab/130",
        name: "수급업체 수행평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["130"],
      },
      {
        url: "/tab/150",
        name: "안전보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["150"],
      },
      {
        url: "/tab/578",
        name: "안전보호구 지급대장",
        icon: "w-line",
        activeCode: "",
        groupName: ["578"],
      },
      {
        url: "/tab/579",
        name: "작업중지제",
        icon: "w-line",
        activeCode: "",
        groupName: ["579"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/448",
        name: "절차서",
        icon: "w-line",
        activeCode: "",
        groupName: ["448"],
      },
      {
        url: "/tab/449",
        name: "안전보건정보 사전조사",
        icon: "w-line",
        activeCode: "",
        groupName: ["449"],
      },
      {
        url: "/tab/151",
        name: "위험성평가협의회",
        icon: "w-line",
        activeCode: "",
        groupName: ["151"],
      },
      {
        url: "/tab/108",
        name: "유해·위험요인 조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["108", "156", "157", "158", "159", "305", "306"],
      },
      {
        url: "/tab/450",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "riskassessment450",
        groupName: ["450", "riskassessment450"],
      },
      {
        url: "/tab/460",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "riskassessment460",
        groupName: ["460", "riskassessment460"],
      },
      {
        url: "/tab/372",
        name: "아차사고 등록",
        icon: "w-line",
        activeCode: "",
        groupName: ["372"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가(3등급)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/475",
        name: "3등급(상·중·하) 판단법",
        icon: "w-line",
        activeCode: "",
        groupName: ["475"],
      },
      {
        url: "/tab/476",
        name: "주간 이행사항 점검 및 회의",
        icon: "w-line",
        activeCode: "",
        groupName: ["476"],
      },
      {
        url: "/tab/477",
        name: "일일TBM 활동",
        icon: "w-line",
        activeCode: "",
        groupName: ["477"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가 Tool(3단계 판단법)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/587",
        name: "위험성평가 사전회의일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["587"],
      },
      {
        url: "/tab/584",
        name: "정기 위험성평가(3단계법)",
        icon: "w-line",
        activeCode: "",
        groupName: ["584"],
      },
      {
        url: "/tab/588",
        name: "정기 위험성평가 교육 일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["588"],
      },
      {
        url: "/tab/589",
        name: "수시 위험성평가(OPS)",
        icon: "w-line",
        activeCode: "",
        groupName: ["589"],
      },
      {
        url: "/tab/590",
        name: "수시 위험성평가 교육 일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["590"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가 실시 자료(빈도 강도법)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/591",
        name: "위험성평가 대상",
        icon: "w-line",
        activeCode: "",
        groupName: ["591"],
      },
      {
        url: "/tab/583",
        name: "유해·위험요인 분류표",
        icon: "w-line",
        activeCode: "",
        groupName: ["583"],
      },
      {
        url: "/tab/592",
        name: "위험성 결정",
        icon: "w-line",
        activeCode: "",
        groupName: ["592"],
      },
      {
        url: "/tab/596",
        name: "위험성 결과",
        icon: "w-line",
        activeCode: "",
        groupName: ["596"],
      },
      {
        url: "/tab/595",
        name: "감소대책 수립 및 실행",
        icon: "w-line",
        activeCode: "",
        groupName: ["595"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 파악 조사표",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/582",
        name: "관리자(사업장 순회점검)",
        icon: "w-line",
        activeCode: "",
        groupName: ["582"],
      },
      {
        url: "/tab/581",
        name: "근로자(상시제안 및 청취조사)",
        icon: "w-line",
        activeCode: "",
        groupName: ["581"],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 위험성평가 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "건설업",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "제조업",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "교육서비스업",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 사고사례 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "2023년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2022년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2021년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 산재관련 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "2023년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2022년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2021년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/",
    name: "작업계획서",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/246",
        name: "고위험작업계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["246"],
      },
      {
        url: "/tab/247",
        name: "위험작업계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["247"],
      },
      {
        url: "/tab/248",
        name: "일반작업계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["248"],
      },
      {
        url: "/tab/249",
        name: "기타작업계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["249"],
      },
    ],
  },
  {
    url: "/",
    name: "작업허가서",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/457",
        name: "고위험작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["457"],
      },
      {
        url: "/tab/458",
        name: "일반작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["458"],
      },
      {
        url: "/tab/459",
        name: "기타작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["459"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/451/page",
        name: "(중대)산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["451"],
      },
      {
        name: "비상조치 처리 절차",
        icon: "w-line",
        submenu: [
          {
            url: "/filelibrary/454",
            name: "상황별 비상 대비 시나리오",
            activeCode: "filelibrary-454",
            icon: "w-line",
            groupName: ["454"],
          },
          {
            url: "/filelibrary/455",
            name: "사고별·시간별 시나리오",
            activeCode: "filelibrary-455",
            icon: "w-line",
            groupName: ["455"],
          },
          {
            url: "/",
            name: "비상사태 시나리오",
            activeCode: "",
            icon: "w-line",
            // groupName: [""],
          },
        ],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/307",
        name: "안전사고 발생 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["307"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["244"],
      },
      {
        url: "/tab/245",
        name: "재발방지계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["245"],
      },
      {
        url: "/tab/443",
        name: "재발방지 조치 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["443"],
      },
    ],
  },
  {
    url: "/",
    name: "보건관리 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/364",
        name: "일정 관리",
        icon: "w-line",
        activeCode: "",
        groupName: ["364"],
      },
      {
        url: '/tab/452',
        name: '유소견자 건강상담 사후관리',
        icon: 'w-line',
        activeCode: '',
        groupName: ['452'],
      },
      {
        url: '/tab/490',
        name: '물질 안전·보건자료 게시',
        icon: 'w-line',
        activeCode: '',
        groupName: ['490'],
      },
      {
        url: "/tab/447",
        name: "MSDS 리스트 관리",
        icon: "w-line",
        activeCode: "",
      },
      {
        name: "건강관리실 현황",
        icon: "w-line",
        activeCode: "",
        submenu: [
          {
            url: "/tab/365",
            name: "의약품 지급 현황",
            icon: "w-line",
            activeCode: "",
            groupName: ["365"],
          },
          {
            url: "/tab/366",
            name: "의료기구 점검현황",
            icon: "w-line",
            activeCode: "",
            groupName: ["366"],
          },
        ],
      },
      {
        url: "/tab/370",
        name: "보건자료",
        icon: "w-line",
        activeCode: "",
        groupName: ["370"],
      },
    ],
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/413",
        name: "안전·보건 점검",
        activeCode: "filelibrary-413",
        icon: "w-line",
        groupName: ["413"],
      },
      {
        url: "/filelibrary/418",
        name: "안전·보건 교육",
        activeCode: "filelibrary-418",
        icon: "w-line",
        groupName: ["418"],
      },
      {
        url: "/filelibrary/423",
        name: "관련 법령 등",
        activeCode: "filelibrary-423",
        icon: "w-line",
        groupName: ["423"],
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "안전보건관리책임자 지시사항",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ["16"],
      },
      {
        url: "/community/healthinfo",
        name: "안전·보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ["18"],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ["19"],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ["17"],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
          {
            url: "/mypage/sign-update",
            name: "개인서명관리",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
        ],
      },
    ],
  },
];
